import Button from '@material-ui/core/Button';
import { makeStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    modalTitle: {
      marginTop: '26px',
      marginBottom: '85px',
      marginLeft: '23px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 18,
      lineHeight: '21px',
      color: '#2C2D3E',
    },
    closeButton: {
      position: 'relative',
      marginLeft: '339px',
      marginTop: '15px',
      width: '30px',
      height: '30px',
      background: '#FFFFFF',
      border: '1px solid #2C2D3E',
      borderRadius: '3px',
      fontSize: 'small',
    },
    leftFormInput: {
      padding: '0px',
      width: '320px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      marginLeft: '59px',
      marginBottom: '26px',
      appearance: 'none',
    },
    rightFormInput: {
      padding: '0px',
      width: '320px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      marginLeft: '20px',
      appearance: 'none',
    },
    xInButton: {
      marginTop: '8px',
      marginLeft: '8px',
      color: '#2C2D3ECC',
    },
    leftText: {
      marginTop: '10px',
      marginBottom: '8px',
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 14,
      lineHeight: '17px',
      color: '#2C2D3E',
      marginLeft: '38px',
    },
    rightText: {
      marginTop: '10px',
      marginBottom: '8px',
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 14,
      lineHeight: '16px',
      color: '#2C2D3E',
      verticalAlign: 'center',
      marginLeft: '38px',
    },
    line: {
      position: 'relative',
      width: '544px',
      size: '0px',
      color: '#2c2d3e',
      opacity: 0.3,
      display: 'inline-block',
      align: 'center',
      marginBottom: '8px',
    },
    actionIcon: {
      position: 'relative',
      top: '1px',
      color: '#3C419A',
    },
  }),
);

export const CancelButton = withStyles(() => ({
  root: {
    width: '147px',
    marginLeft: '375px',
    marginTop: '23px',
    padding: '0px 0px 0px 0px',
    fontSize: 14,
    height: '36px',
    left: '59px',
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
}))(Button);
